import gql from 'graphql-tag';

export const UPDATE_SETTING = gql`
  mutation updateSettingsForDeployedProduct($settings: [SettingInput]) {
    updateSettingsForDeployedProduct(settings: $settings)
  }
`;
